export const toggleIdInArray = (array, id) => {
  if (!id) return array
  if (array?.includes?.(id)) return array?.filter?.((item) => item !== id)
  else return [...array || [], id]
}

export const round = (item, decimals = 2) =>
  Math.round(item * Math.pow(10, decimals)) / Math.pow(10, decimals)
